import api from './api';

export const workItemService = {
  // Get all work items
  getAll: async (params = {}) => {
    const response = await api.get('/work-items/', { params });
    return response; // Response is already unwrapped by interceptor
  },

  // Get work item by ID
  getById: async (id) => {
    const response = await api.get(`/work-items/${id}`);
    return response; // Response is already unwrapped by interceptor
  },

  // Get categories
  getCategories: async () => {
    const response = await api.get('/work-items/categories');
    return response; // Response is already unwrapped by interceptor
  },

  // Create work item
  create: async (workItemData) => {
    const response = await api.post('/work-items/', workItemData);
    return response; // Response is already unwrapped by interceptor
  },

  // Update work item
  update: async (id, workItemData) => {
    const response = await api.put(`/work-items/${id}`, workItemData);
    return response; // Response is already unwrapped by interceptor
  },

  // Delete work item (soft delete by default)
  delete: async (id, hardDelete = false) => {
    const response = await api.delete(`/work-items/${id}`, {
      params: { hard_delete: hardDelete }
    });
    return response; // Response is already unwrapped by interceptor
  },

  // Restore archived work item
  restore: async (id) => {
    const response = await api.post(`/work-items/${id}/restore`);
    return response; // Response is already unwrapped by interceptor
  },

  // Bulk create work items
  bulkCreate: async (workItemsData) => {
    const response = await api.post('/work-items/bulk-create', workItemsData);
    return response; // Response is already unwrapped by interceptor
  },

  // Import work items from CSV
  importFromCSV: async (file, updateExisting = true) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/work-items/import?update_existing=${updateExisting}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response; // Response is already unwrapped by interceptor
  }
};
